<li *ngIf="selected <= (numberOfItems+selected)" class="box box-1 mr-2 ml-2" [ngClass]="{ 'selected': currentSelectPicture === selected }">
  <img src="{{srcUrl}}"/>
</li>
